

const DOMAINS = Object.freeze({
  KR: 'ljc.coupang.com',
  TW: 'ljc.tw.coupang.com',
  JP: 'ljc.rocketnow.co.jp',
});

export default class EndPointsConfig {
  private readonly appCode: string;
  private readonly host?: string;
  private readonly mode: Mode;
  private readonly market?: string;
  private baseUrl: string;

  constructor({ appCode, host, market, mode = 'production' }: Config) {
    // FIXME: Should be refactored after TS version up
    if (host && !host.startsWith('https://')) {
      throw new Error('host param should be starts with https://');
    }

    this.appCode = appCode;
    this.host = host;
    this.market = market;
    this.mode = mode;

    this.baseUrl = this.host || this.getBaseUrl();
  }

  /**
   * Return single submit api endpoint
   *
   * @returns {string} endpoint
   */
  getSingleSubmitEndpoint(): string {
      return `${this.baseUrl}/api/v3/web/submit?appCode=${this.appCode}&market=${this.market}`;
   
  }

  private getBaseUrl() {
    const host = DOMAINS[this.market as keyof typeof DOMAINS] || DOMAINS['KR'];
    return `https://${host}`;
  }

}
